import VueRouter from 'vue-router';
import { isReturningUser } from '../../../util';
import { RouteName } from '../../../routes/routes.constants';

/**
 * Redirects returning users to login page only once
 * to still allow the user to navigate to the home
 * should he wish not to login.
 */
export const initReturningUserGuard = (router: VueRouter) => {
    let skip = false;

    router.beforeEach((to, _, next) => {
        // Only process on the first route.
        if (!to.name || skip) {
            return next();
        }
        skip = true;

        const isHomePage = to.name === RouteName.HOME;
        const hasModal = to.query && to.query.modal;

        if (!isHomePage || hasModal) {
            return next();
        }

        if (isReturningUser()) {
            const query = to.query;
            return next({
                name: RouteName.LOGIN,
                params: to.params,
                query: { ...query },
            });
        }

        return next();
    });
};
